import * as React from 'react'

import { cn } from '@/lib/ui/style-helpers'

import { Separator } from '@/components/lemmala-design-system/separator/separator'

export interface SidebarSectionProps {
  title?: string
  collapsed?: boolean
  className?: string
}

export const SidebarSection = React.forwardRef<HTMLDivElement, SidebarSectionProps>(
  ({ title, collapsed = false, className }, ref) => {
    const showSeparator = collapsed || !title

    return (
      <div
        ref={ref}
        className={cn('flex h-6 shrink-0 items-center', className)}
        data-testid='sidebar-section'
      >
        {showSeparator ? (
          <Separator
            orientation='horizontal'
            className='w-full bg-main-border-default'
            role='separator'
          />
        ) : (
          <span className='truncate text-main-foreground-tertiary !text-body-small'>{title}</span>
        )}
      </div>
    )
  },
)
SidebarSection.displayName = 'SidebarSection'
